export default __webpack_public_path__ + "static/media/louki_logo.591632d2.png";